export const Studentlist = [
    {
      key: "1",
      result:"Pass",
      promotion:1,
      AdmissionNo: "STU0001",
      RollNo: "35013",
      name: "Janet",
      class: "Year 3",
      section: "Jupiter",
      gender: "Female",
      status: "Active",
      DateofJoin: "25 Mar 2025",
      DOB: "10 Jan 2015",
      imgSrc: "assets/img/students/student-01.jpg"
    },
    {
      key: "2",
      result:"Pass",
      promotion:1,
      AdmissionNo: "STU0002",
      RollNo: "35013",
      name: "Joann",
      class: "Year 4",
      section: "Mars",
      gender: "Male",
      status: "Active",
      DateofJoin: "18 Mar 2025",
      DOB: "19 Aug 2014",
      imgSrc: "assets/img/students/student-02.jpg"
    },
    {
      key: "3",
      result:"Pass",
      promotion:1,
      AdmissionNo: "STU0003",
      RollNo: "35011",
      name: "Kathleen",
      class: "Year 2",
      section: "Jupiter",
      gender: "Female",
      status: "Active",
      DateofJoin: "14 Mar 2025",
      DOB: "05 Dec 2017",
      imgSrc: "assets/img/students/student-03.jpg"
    },
    {
      key: "4",
      result:"Pass",
      promotion:1,
      AdmissionNo: "STU0004",
      RollNo: "35010",
      name: "Gifford",
      class: "Year 8",
      section: "Mars",
      gender: "Male",
      status: "Active",
      DateofJoin: "27 Feb 2025",
      DOB: "22 Mar 2018",
      imgSrc: "assets/img/students/student-04.jpg"
    },
    {
      key: "5",
      result:"Pass",
      promotion:1,
      AdmissionNo: "STU0005",
      RollNo: "35009",
      name: "Lisa",
      class: "Year 2",
      section: "Mars",
      gender: "Female",
      status: "Inactive",
      DateofJoin: "13 Feb 2025",
      DOB: "13 May 2017",
      imgSrc: "assets/img/students/student-05.jpg"
    },
    {
      key: "6",
      result:"Fail",
      promotion:0,
      AdmissionNo: "STU0006",
      RollNo: "35008",
      name: "Ralph",
      class: "Year 3",
      section: "Mars",
      gender: "Male",
      status: "Active",
      DateofJoin: "11 Feb 2025",
      DOB: "20 Jun 2015",
      imgSrc: "assets/img/students/student-06.jpg"
    },
    {
      key: "7",
      result:"Fail",
      promotion:0,
      AdmissionNo: "STU0007",
      RollNo: "35007",
      name: "Julie",
      class: "Year 5",
      section: "Jupiter",
      gender: "Female",
      status: "Active",
      DateofJoin: "24 Jan 2025",
      DOB: "18 Sep 2013",
      imgSrc: "assets/img/students/student-07.jpg"
    },
    {
      key: "8",
      result:"Pass",
      promotion:1,
      AdmissionNo: "STU0008",
      RollNo: "35006",
      name: "Ryan",
      class: "Year 6",
      section: "Jupiter",
      gender: "Male",
      status: "Active",
      DateofJoin: "19 Jan 2025",
      DOB: "26 Nov 2012",
      imgSrc: "assets/img/students/student-08.jpg"
    },
    {
      key: "9",
      result:"Pass",
      promotion:1,
      AdmissionNo: "STU0009",
      RollNo: "35005",
      name: "Susan",
      class: "Year 8",
      section: "Mars",
      gender: "Female",
      status: "Inactive",
      DateofJoin: "08 Jan 2025",
      DOB: "26 May 2010",
      imgSrc: "assets/img/students/student-09.jpg"
    },
    {
      key: "10",
      result:"Fail",
      promotion:0,
      AdmissionNo: "STU0011",
      RollNo: "35004",
      name: "Richard",
      class: "Year 7",
      section: "Mars",
      gender: "Male",
      status: "Active",
      DateofJoin: "22 Jan 2025",
      DOB: "06 Oct 2011",
      imgSrc: "assets/img/students/student-10.jpg"
    },
    {
      key: "11",
      result:"Pass",
      promotion:1,
      AdmissionNo: "STU0010",
      RollNo: "35003",
      name: "Veronica",
      class: "IX",
      section: "Jupiter",
      gender: "Female",
      status: "Active",
      DateofJoin: "15 Dec 2025",
      DOB: "27 Dec 2009",
      imgSrc: "assets/img/students/student-11.jpg"
    }
  ]
  